export default "__VITE_ASSET__Qr0WcLHk__"